module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-ExtraBold.cc8fdec1.ttf";